import React, { CSSProperties } from 'react'
import { Flex, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import {
  colorBgButtonSubtleHovered,
  colorBgSuccessHovered,
  colorBgSucessBold, colorBgWarningBold, colorBgWarningHovered, colorTextSubtle,
} from '../../../themes/primaryThemeDefault'
import { GreenDotIcon, GreyDotIcon, YellowDotIcon } from '../../../../assets/icons'

export enum STATUS {
  DRAFT,
  SCHEDULED,
  PUBLISHED,
}

interface PropsStatusTag {
  status: STATUS
  style?: CSSProperties
}

export enum STATUS_STRING {
  DRAFT= 'Draft',
  SCHEDULED = 'Scheduled',
  PUBLISHED = 'Published',
}

interface PropsStringStatusTag {
  status: STATUS_STRING
  style?: CSSProperties
}

export const VersionStatusTag: React.FC<PropsStatusTag> = ({ status, style }) => {
  const { t } = useTranslation()

  const getTag = (): { value: string, color: string, bgColor: string, dot: React.ReactElement } | undefined => {
    switch (status) {
      case STATUS.PUBLISHED:
        return {
          value: t(`HelpPage:list.label.published`),
          color: colorBgSucessBold,
          bgColor: colorBgSuccessHovered,
          dot: <GreenDotIcon />,
        }
      case STATUS.SCHEDULED:
        return {
          value: t(`HelpPage:list.label.scheduled`),
          color: colorBgWarningBold,
          bgColor: colorBgWarningHovered,
          dot: <YellowDotIcon />,
        }
      case STATUS.DRAFT:
        return {
          value: t(`HelpPage:list.label.draft`),
          color: colorTextSubtle,
          bgColor: colorBgButtonSubtleHovered,
          dot: <GreyDotIcon />,
        }
      default:

        return undefined
    }
  }

  return (
    <Flex
      align="center"
      justify="center"
      gap={4}
      style={{
        backgroundColor: getTag()?.bgColor,
        borderRadius: '27px',
        height: '28px',
        width: '95px',
        ...style
      }}
    >
      {getTag()?.value && getTag()?.dot}
      <Typography.Text style={{ color: getTag()?.color, fontSize: '14px', fontWeight: 700 }}>
        {getTag()?.value}
      </Typography.Text>
    </Flex>
  )
}


export const StringVersionStatusTag: React.FC<PropsStringStatusTag> = ({ status, style }) => {
  const { t } = useTranslation()

  const getTag = (): { value: string, color: string, bgColor: string, dot: React.ReactElement } | undefined => {
    switch (status) {
      case STATUS_STRING.PUBLISHED:
        return {
          value: t(`HelpPage:list.label.published`),
          color: colorBgSucessBold,
          bgColor: colorBgSuccessHovered,
          dot: <GreenDotIcon />,
        }
      case STATUS_STRING.SCHEDULED:
        return {
          value: t(`HelpPage:list.label.scheduled`),
          color: colorBgWarningBold,
          bgColor: colorBgWarningHovered,
          dot: <YellowDotIcon />,
        }
      case STATUS_STRING.DRAFT:
        return {
          value: t(`HelpPage:list.label.draft`),
          color: colorTextSubtle,
          bgColor: colorBgButtonSubtleHovered,
          dot: <GreyDotIcon />,
        }
      default:

        return undefined
    }
  }

  return (
    <Flex
      align="center"
      justify="center"
      gap={4}
      style={{
        backgroundColor: getTag()?.bgColor,
        borderRadius: '27px',
        height: '28px',
        width: '95px',
        ...style
      }}
    >
      {getTag()?.value && getTag()?.dot}
      <Typography.Text style={{ color: getTag()?.color, fontSize: '14px', fontWeight: 700 }}>
        {getTag()?.value}
      </Typography.Text>
    </Flex>
  )
}

